import {
    ArrowLeft,
    ArrowUpRight,
    Funnel,
    X
} from "@phosphor-icons/react";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useQuery } from "@tanstack/react-query";
import PageLoader from "../loader/PageLoader";
import PastBookingCard from "./PastBookingCard";





const PastBookings = ({ close }) => {

    const [filteredData, setFilteredData] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState({
        roomNumber: "",
        otaId : ""
    });
    const [msg,setMsg] = useState("");
    const [pastBookingCard,setPastBookingCard] = useState(false); 
    const [activeBooking,setActiveBooking] = useState(null);

    const [openFilter, setOpenFilter] = useState(false);
    const hotelId = localStorage.getItem("hotelId");
    
 

    // Function to fetch initial past bookings
    const fetchPastBooking = async (hotelId) => {
        try {
            const response = await axiosInstance.get(
                `api/v1/hotels/${hotelId}/bookings/past-bookings`
            );
            
            const data = response.data?.pastBookings;
            if (data === null || data === undefined) {
                // If pastBookings is not available, return the message
                // console.warn("No past bookings found, returning message:", response.data.message);
                return  ""; // Fallback message if no message is provided
            }
            if (!Array.isArray(data)) {
                return data;
            }
            return data;
        } catch (error) {
            console.error("Error fetching past bookings:", error);
            throw error;
        }
    };
 
    const { data: fetchData, isLoading, isFetching, error, refetch } = useQuery({
        queryKey: ["pastBookings", hotelId],
        queryFn: () => fetchPastBooking(hotelId),
        staleTime: 5000,  // Prevent refetching automatically
        refetchOnWindowFocus: true,  // Disable refetching on window focus
        refetchInterval: 3000,  // Poll every 30 seconds (adjust as needed)
    });
 
    useEffect(() => {
        if (Array.isArray(fetchData)) {
            setFilteredData(fetchData);
           
        }
        else{
            setMsg(fetchData);
        }
    }, [fetchData]);


    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setAppliedFilters((prev)=>({
            ...prev,[name]:value
        }));
    };

    const resetFilters = () => {
 
        setFilteredData(fetchData);
        setAppliedFilters({
            roomNumber: "",
        });
        setOpenFilter(false);
    };

    const applyFilters = () => {

        if (!Array.isArray(fetchData)) {
            console.error("No data available for filtering");
            return;
        }

        if(appliedFilters.otaId && appliedFilters.roomNumber){
            const filtered = fetchData.filter((booking)=>{
                const rooms = booking.rooms_booked;
                if(booking.ota_id===appliedFilters.otaId  &&  rooms.includes(appliedFilters.roomNumber) ){
                    return true;   
                }
                else{
                    return false;
                }
            })
 
            setOpenFilter(false);
            setFilteredData(filtered);
            return;
        }

        if(appliedFilters.otaId){
       

            const filtered = fetchData.filter((booking)=>{
                const rooms = booking.rooms_booked;
                if(booking.ota_id===appliedFilters.otaId || rooms.includes(appliedFilters.roomNumber)){
                    return true;   
                }
                else{
                    return false;
                }
            })
 
            setOpenFilter(false);
            setFilteredData(filtered);
            return;
        }

        if(appliedFilters.roomNumber){
            const filtered = fetchData.filter((booking)=>{
                const rooms = booking.rooms_booked;
                if(rooms.includes(appliedFilters.roomNumber)){
                    return true;   
                }
                else{
                    return false;
                }
            })
            // console.log("Filterd Data : " + filtered);
            setOpenFilter(false);
            setFilteredData(filtered);
            return;
        }
    
        setFilteredData(fetchData);
        setOpenFilter(false);
     
    };

    const openPastBookingCard = (booking)=>{
        setPastBookingCard(true);
        setActiveBooking(booking);
    }


    // Hotel ID is not there return
    if (!hotelId) {
        console.error("Hotel ID not found in localStorage");
        return;
    }

    return (
        <>
            {!isFetching && (isLoading && <PageLoader />)}
            <div className="p-4">

                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                    <div className="flex gap-2 items-center">
                        <button
                            className="bg-[#F2F7FF] border-[1.5px] rounded-md p-1 z-0 mr-1"
                            onClick={() => close(false)}
                        >
                            <ArrowLeft size={19} />
                        </button>
                        <h2 className="text-[#262B33] font-medium tracking-[2.5px] text-xl">
                            PAST BOOKINGS
                        </h2>
                    </div>
                    <button
                        className="flex items-center gap-2 border-[1.5px] rounded-md px-2 py-1"
                        onClick={() => setOpenFilter(!openFilter)}
                    >
                        <Funnel size={18} /> Filter
                    </button>
            
                </div>
 
                {openFilter && (
                    <div className="absolute top-32 right-7 mt-2 border-[1.5px] rounded-md bg-white text-sm w-96 overflow-hidden z-10">
                        
                        <div className="flex items-center justify-between bg-[#F2F7FF] px-3 py-2">
                            <h2 className="font-semibold">Filters</h2>
                            <button
                                onClick={() => setOpenFilter(false)}
                                className="bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                            >
                                <X weight="bold" size={15} />
                            </button>
                        </div>

                        {/* Filter By Room Number */}
                        <div className="p-2 flex flex-col gap-3">
                            <div>
                                <label htmlFor="" className="font-medium">
                                    Room Number
                                </label>
                                <select
                                    className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                        appliedFilters.roomNumber === ""
                                            ? "text-gray-500"
                                            : "text-black"
                                    }`}
                                    name="roomNumber"
                                    value={appliedFilters.roomNumber}
                                    onChange={handleFilterChange}
                                >
                                    <option
                                        value=""
                                        className="text-gray-500"
                                    >
                                        Choose Room Numbers
                                    </option>
                                   
                                    {Array.isArray(fetchData) &&
                                        fetchData &&
                                        [...new Set(fetchData.flatMap(booking => booking.rooms_booked || []))].map((room, idx) => (
                                            <option key={idx} value={room}>
                                              {room}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>

                        {/* Ota Id  */}
                        <div className="p-2 flex flex-col gap-3">
                            <div>
                                <label htmlFor="" className="font-medium">
                                    Booking 
                                </label>
                                <select
                                    className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                        appliedFilters.otaId === ""
                                            ? "text-gray-500"
                                            : "text-black"
                                    }`}
                                    name="otaId"
                                    value={appliedFilters.otaId}
                                    onChange={handleFilterChange}
                                >
                                    <option
                                        value=""
                                        className="text-gray-500"
                                    >
                                        Choose Booking 
                                    </option>
                                   
                                    {Array.isArray(fetchData) &&
                                        fetchData &&
                                        fetchData.map((booking, index) => {
                                            return <option className="text-gray-500" key={index} value={booking.ota_id}>
                                                {booking.ota_id}
                                            </option> 
                                        })
                                    }
                                </select>
                            </div>
 
 
                        </div>
                        
                        {/* Reset */}
                        <div className="bg-[#F2F7FF] px-3 py-2 flex items-center justify-between">
                            <button
                                className="text-[#ff7378] border-[1.5px] rounded-md px-2 py-1"
                                onClick={resetFilters}
                            >
                                Reset
                            </button>
                            <button
                                className="bg-[#ff7378] px-3 py-1 rounded-md"
                                onClick={applyFilters}
                            >
                                Apply Filter
                            </button>
                        </div>
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">

                    {Array.isArray(filteredData) && filteredData.map((booking,index)=>{
                        return <div className="bg-white rounded-md p-3 border border-gray-200 shadow-black" key={booking.booking_id}>
                            {/* Booking Id */}
                            <div className="flex items-start justify-between pb-3 mb-2 border-b">
                                <div className="min-w-0">
                                    <h2 className="text-[#BFC4CC] text-lg leading-tight">
                                        Booking#
                                    </h2>
                                    <span className="text-xl text-[#262B33] block truncate" title={booking.ota_id || ""}>
                                        { booking.ota_id &&  booking.ota_id.length > 10 ? booking.ota_id.substring(0, 10) + "..."  : booking.ota_id || "OTAID" }
                                    </span>
                                    {booking.booking_name && (
                                        <span className="text-xs text-[#737880] block truncate" title={booking.booking_name}>
                                            {booking.booking_name}
                                        </span>
                                    )}
                                </div>
                                <button className="bg-[#FFFF] p-1.5 z-0 shrink-0" key={index}>
                                    <ArrowUpRight size={21} color="#0B22B2"  onClick={()=>openPastBookingCard(booking)} />
                                </button>
                            </div>

                            {booking.booking_code && (
                                <div className="flex items-center justify-between my-2 border-b pb-2">
                                    <h2 className="text-[#737880]">Booking Code</h2>
                                    <span className="font-mono font-semibold tracking-wider text-[#262B33] bg-[#EEF0FB] border-[1.5px] border-[#BFC4CC] rounded-md px-2 py-0.5 truncate max-w-[55%]" title={booking.booking_code}>
                                        {booking.booking_code}
                                    </span>
                                </div>
                            )}

                            {/* Rooms Booked */}
                            <div className="flex items-center  my-2 border-b pb-2">
                                <h2 className="text-[#737880] me-auto">Rooms Booked</h2>
                                {booking.rooms_booked && booking.rooms_booked.length > 0 ? (
                                        booking.rooms_booked.map((room, index) => (
                                            <div className="" key={index}>
                                                <span className="text-[#FF5A5F] font-semibold">{room}</span>
                                                {index < booking.rooms_booked.length - 1 && <span className="text-black">, </span>}
                                            </div>
                                        ))
                                    ) : (
                                        <span className="text-[#BFC4CC]">No rooms booked</span>
                                )}
                            </div>
                            <div className="flex items-center justify-between my-2 border-b pb-2">
                                <h2 className="text-[#737880]">Guests In Booking</h2>
                                <span className="text-sm text-[#FFFF] bg-[#737880] py-1 px-2 rounded-md">{booking?.total_guests || "0"}</span>
                            </div>
                            <div className="flex items-center justify-between my-2  pb-1">
                                <h2 className="text-[#737880]">Total Requests</h2>
                                <span className="text-sm text-[#FFFF] bg-[#737880] py-1 px-2 rounded-md">{booking?.total_requests || "0"}</span>
                            </div>
                        </div>
                    })}

                </div>

                {/* Show this Message */}
                {msg && 
                    <div className="flex justify-center items-center h-screen w-full">
                        {msg}
                    </div>
                }

            </div>
            {
                pastBookingCard && <PastBookingCard hotelId ={hotelId} bookingId ={activeBooking?.booking_id} booking={activeBooking} setPastBookingCard={setPastBookingCard} />
            }
        </>
    );
};

export default PastBookings;
